// src/utils/textUtils.js

/**
 * Ensures consistent spacing after commas in strings.
 * Example: "Male,Female,Other" → "Male, Female, Other"
 *
 * Handles null/undefined safely.
 */
export const addSpaceAfterCommas = (text) => {
  if (!text) return "";
  return String(text).replace(/,\s*/g, ", ");
};
